import {ACTION_CODE} from './_actionCode';
import {DealService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DELETE_DEAL';

export async function deleteDeal(userData: Record<string, string>, dealId: string) {
    try {
        LoggerService.logInfo('Action - deleteDeal - Start');

        const deleteDealResult = await DealService.deleteDeal(userData, dealId);

        LoggerService.logInfo('Action - deleteDeal - End - Success');

        return ResultModel.newSuccessResult(deleteDealResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - deleteDeal - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
